import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Shell } from "../components/Shell";

const items = [
    ["Confirm & choose", "Confirm you're 18+, pick your language (English, Hindi or Hinglish) and the concern that's most present."],
    ["Four free questions", "One question per screen, with a scenario, options and space to write. Your answers save automatically — refresh-safe."],
    ["A free preview", "We reflect back a short, personal starting point using only your four answers. No invented conclusions."],
    ["₹299 one-time", "Choose to continue. We create an order marked PENDING. A screenshot or reference is never treated as proof."],
    ["Manual verification", "The owner independently checks the money was actually received, then approves your order in a secure dashboard."],
    ["The remaining 14", "Once approved, questions 5–18 unlock — only for your account. Each adapts to what you shared earlier."],
    ["Your report", "A structured report separating what you said, possible interpretations, and what remains unknown, with three realistic next steps."],
    ["The companion", "Continue in conversation with an empathetic AI companion that uses your context only with your consent."],
];

export default function HowItWorks() {
    const { t, user } = useApp();
    const nav = useNavigate();
    return (
        <Shell eyebrow={t("nav.how")} title="How WHY-AM works" intro="A clear, honest walk-through of the whole experience — including exactly where payment and human verification fit in.">
            <ol className="space-y-5">
                {items.map(([h, b], i) => (
                    <li key={h} className="card-soft p-6 flex gap-5">
                        <span className="shrink-0 h-9 w-9 rounded-full bg-forest text-ivory flex items-center justify-center font-serif">{i + 1}</span>
                        <div><h3 className="text-xl text-forest">{h}</h3><p className="mt-1 text-sm text-charcoal/75 leading-relaxed">{b}</p></div>
                    </li>
                ))}
            </ol>
            <div className="mt-10 card-soft p-6 bg-forest/5">
                <h3 className="text-xl text-forest">What WHY-AM can and cannot do</h3>
                <p className="mt-2 text-sm text-charcoal/75 leading-relaxed">WHY-AM can help you slow down, notice patterns and clarify what you need. It cannot diagnose conditions, read anyone else's mind, predict outcomes, or replace professional care. Sometimes a situation is external or still unclear — and the report is comfortable saying so.</p>
            </div>
            <button onClick={() => nav(user ? "/assessment" : "/onboarding")} className="btn-primary mt-10 px-6 py-3.5 font-medium">{t("nav.start")}</button>
        </Shell>
    );
}
